import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import { compose } from "recompose";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";
import withFormStyles from "../components/forms/withFormStyles";

const getCronJobTitle = (record, translate) =>
  `${translate("cron-job.label")} ${record.id} (${record.name})`;

const Edit = ({ classes, ...props }) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={false}
      className={classes.root}
      title={<DynamicTitleWithTooltip getTitle={getCronJobTitle} />}
    >
      <Form />
    </RaEdit>
  );
};
export default compose(withFormStyles)(Edit);
